"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DiscardAlert = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    dialog: {
      zIndex: '1400 !important'
    },
    avatar: {
      backgroundColor: theme.palette.error.main,
      width: 46,
      height: 46,
      marginRight: theme.spacing(2)
    },
    icon: {
      color: 'white'
    },
    root: {
      width: '420px',
      borderTop: "4px solid ".concat(theme.palette.error.main)
    },
    actions: {
      padding: theme.spacing(2)
    }
  };
});
var Transition = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_material.Fade, (0, _extends2["default"])({
    ref: ref
  }, props));
});
/**
 * @callback renderProp
 * @returns {React.ReactNode}
 */

/**
 * DiscardAlert Component.
 *
 * @deprecated
 *
 * @function
 * @param {object} props - DiscardAlert props.
 * @param {boolean} props.isOpen - Is alert open.
 * @param {renderProp} props.renderActions - Function that renders alert actions.
 * @param {renderProp} props.renderBody - Function that renders alert body.
 * @param {renderProp} props.renderTitle - Function that renders alert title.
 * @returns {React.ReactNode}
 *
 * @example
 * <DiscardAlert
 *   isOpen={isOpen}
 *   renderActions={renderActions}
 *   renderBody={renderBody}
 *   renderTitle={renderTitle}
 * />
 */

var DiscardAlert = function DiscardAlert(_ref) {
  var isOpen = _ref.isOpen,
      renderActions = _ref.renderActions,
      renderBody = _ref.renderBody,
      renderTitle = _ref.renderTitle;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_material.Dialog, {
    className: classes.dialog,
    TransitionComponent: Transition,
    BackdropProps: {
      style: {
        background: 'black',
        opacity: 0.5
      }
    },
    PaperProps: {
      elevation: 1,
      square: false,
      classes: {
        root: classes.root
      }
    },
    disablePortal: true,
    open: isOpen
  }, /*#__PURE__*/_react["default"].createElement(_material.DialogTitle, null, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center"
  }, renderTitle())), /*#__PURE__*/_react["default"].createElement(_material.DialogContent, null, renderBody()), /*#__PURE__*/_react["default"].createElement(_material.DialogActions, {
    className: classes.actions
  }, renderActions()));
};

exports.DiscardAlert = DiscardAlert;
DiscardAlert.propTypes = {
  isOpen: _propTypes["default"].bool.isRequired,
  renderTitle: _propTypes["default"].func.isRequired,
  renderBody: _propTypes["default"].func.isRequired,
  renderActions: _propTypes["default"].func.isRequired
};
/**
 * @type {DiscardAlert}
 */